// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"LicencePage_overlayWrapper__FrCxX","expander":"LicencePage_expander__JGe6B"};